import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import { Link, useLocation, useNavigate } from "react-router-dom"
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useDispatch, useSelector } from "react-redux"
import { signUpActions, signupButtonHandler } from '../../Hooks/slices/signupSlice';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
// signupButtonHandler

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" to="/">
        Notico
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const theme = createTheme();

export default function SignupForm() {
  const [errorSignup, setErrorSignup] = React.useState(false)
  const dispatch = useDispatch()
  const { firstName,
    lastName,
    username,
    password, state } = useSelector((store) => store.signUpReducers)
  const location = useLocation()
  const navigate = useNavigate()
  const pathname = location?.state?.pathname || "/"
  React.useEffect(() => {
    state === "fulfilled" && navigate(pathname)
    state === "idle" && setErrorSignup(false)
    state === "rejected" && setErrorSignup(true)
    state === "rejected" && setTimeout(() => {
      setErrorSignup(false)
    }, 5000)
    setTimeout(() => {
      dispatch(signUpActions.setStateIdleHandler())
    }, 500)

  }, [dispatch, state])

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign up
          </Typography>
          {errorSignup && <Alert severity="error">
            <AlertTitle>Error</AlertTitle>
            Try again — <strong>The input couldn't be processed.</strong>
          </Alert>}
          <Box component="form" noValidate sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  autoComplete="given-name"
                  name="firstName"
                  required
                  fullWidth
                  id="firstName"
                  label="First Name"
                  value={firstName}
                  autoFocus
                  onChange={(e) => dispatch(signUpActions.firstNameHandler(e.target.value))}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  id="lastName"
                  label="Last Name"
                  name="lastName"
                  value={lastName}
                  onChange={(e) => dispatch(signUpActions.lastNameHandler(e.target.value))}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="username"
                  label="username"
                  name="username"
                  value={username}
                  onChange={(e) => dispatch(signUpActions.usernameHandler(e.target.value))}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  value={password}
                  autoComplete="new-password"
                  onChange={(e) => dispatch(signUpActions.passwordHandler(e.target.value))}
                />
              </Grid>
            </Grid>
            <Button
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={() => dispatch(signupButtonHandler(({ firstName, lastName, username, password })))}
            >
              Login
            </Button>
            <Grid container justifyContent="flex-end">
              <Link to="/login" variant="body2">
                Already have an account? Sign in
              </Link>

            </Grid>
          </Box>
        </Box>
        <Copyright sx={{ mt: 5 }} />
      </Container>
    </ThemeProvider>
  );
}